module.exports = __webpack_public_path__ + "img/t1_s.1bb631bd.jpg";